<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">2023WAIC：腾讯云MaaS再升级，AI for Science新突破</div>
      <div class="news-date">2023年7月7日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>7月7日，2023世界人工智能大会·腾讯论坛在上海世博中心举办。论坛以“无限可能”为主题，腾讯公布了一系列AI创新进展。</p>
        <p>
          <span class="mark-text highlight">在业界普遍关注的AI大模型领域，腾讯云公布了技术底座、创新场景、AI for Science三大领域升级</span>
          ，也是继6月行业大模型技术解决方案后的再次更新。
        </p>
        <p>其中，自研星脉高性能计算网络、向量数据库的最新升级，将为大模型的行业应用提供更强大的底层能力；金融风控、交互翻译、数智人等创新场景，为行业大模型行业探索提供更多可能性；AI for Science，持续将AI大模型等最新技术应用在天文探索、文化考古领域，以科技助力可持续社会价值创新。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news37.jpeg"/>
          </div>
        </div>
        <p>腾讯集团副总裁、政企业务总裁李强：</p>
        <p class="gray">“大模型时代，数据、网络、算力构成了底层基础设施的“铁三角”，除了提供MaaS服务，腾讯云也在通过云服务的方式，为行业大模型的打造提供HCC高性能计算集群、向量数据库等基础设施服务。”</p>
        <p>腾讯云副总裁、腾讯云智能负责人、优图实验室负责人吴运声：</p>
        <p class="gray">“AI大模型技术发展和产业探索，离不开产业链协同和生态共建，腾讯希望与行业伙伴携手，共同推进大模型在产业领域的创新和落地。”</p>
        <p>
          在本次大会上，
          <span class="mark-text highlight">腾讯作为代表性大模型企业，加入由中国信通院发起成立的大模型生态合作共同体</span>
          ，未来将围绕大模型开放服务平台、产学研交流等层面展开支持。
        </p>
        <br>

        <div class="news-content-mark">
          <h2>腾讯云MaaS再升级</h2>
          <h2>落地金融风控、交互翻译、数智人等创新场景</h2>
        </div>
        <p>快速了解、应用大模型能力，是新一轮人工智能技术浪潮中，保持市场核心竞争力的关键，这也成为越来越多企业探索的方向。</p>
        <p>为了解决企业应用模型技术的现实挑战，如计算资源少、数据质量差、投入成本高、专业经验少等限制，腾讯云在6月19日首次公布行业大模型研发进展，依托腾讯云TI平台打造行业大模型精选商店，为客户提供MaaS（Model-as-a-Service）一站式服务，助力客户构建专属大模型及智能应用。目前，腾讯云已经为传媒、文旅、政务、金融等10余个行业提供了超过50个大模型行业解决方案。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news37/news37_1.png"/>
          </div>
        </div>
        <p><span class="mark-text highlight">在本次世界人工智能大会上，腾讯云再次公布了多项升级。</span></p>
        <p>
          <span class="mark-text highlight">在技术底座领域</span>
          ，自研星脉高性能计算网络、向量数据库，为大模型的行业应用提供更充沛的算力基础设施。
        </p>
        <p>其中，最新升级的腾讯云自研星脉高性能计算网络，能提升40%的GPU利用率，节省30%~60%的模型训练成本，为AI大模型带来10倍通信性能提升。基于腾讯云新一代算力集群HCC，可支持10万卡的超大计算规模。腾讯云AI原生向量数据库，最高支持10亿级向量检索规模，延迟控制在毫秒级，相比传统单机插件式数据库检索规模提升10倍，同时具备百万级每秒查询（QPS）的峰值能力。</p>
        <p>
          <span class="mark-text highlight">在应用创新方面</span>
          ，腾讯云行业大模型能力应用到金融风控、交互翻译、数智人客服等场景中，极大提升了智能应用效率。
        </p>
        <p>行业大模型加持的金融风控解决方案，相比之前有了10倍效率提升，通过腾讯积累超过20年的黑灰产对抗经验和上千个真实业务场景，整体反欺诈效果比传统模式有20%左右的提升。企业可以基于prompt模式，迭代风控能力，从样本收集、模型训练到部署上线，实现全流程零人工参与，建模时间也从2周减少到仅需2天。即便样本积累有限的情况下，也可以完成快速搭建，跳过“冷启动”过程。</p>

        <p>
          <span class="mark-text highlight">在交互翻译领域</span>
          ，基于行业大模型技术加持，同传技术不再需要百万级的训练数据，仅需“小样本”训练就能实现较好效果，专业领域的翻译也能减少人工调优的参与，保障翻译效果，在多个垂直行业落地。其中，腾讯同传已经连续六年为世界人工智能大会主论坛提供AI同传服务。
        </p>
        <p>
          <span class="mark-text highlight">在数智人领域</span>
          ，今年腾讯云推出了小样本数字人工厂，仅需少量数据、24小时内即可复刻2D数字分身，让企业应用数智人服务成本大大降低。
        </p>
        <p>现在，依托AI生成算法，数智人3D形象的复刻速度得到大幅提升，通过生成式动作驱动，结合行业大模型能力，可让企业获得更“个性化、专业、自然逼真”的数智员工，让“面对面”专业服务成为可能。</p>
        <br>

        <div class="news-content-mark">
          <h2>AI for Science新突破</h2>
          <h2>探星计划以云+AI探测2颗快速射电暴</h2>
        </div>
        <p>腾讯云行业大模型应用，除了在产业数字化转型发挥效应，也加速推动大模型等AI技术在科学计算领域的应用，探索“科技向善”的更多可能。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news37/news37_2.png"/>
          </div>
        </div>
        <p>
          <span class="mark-text highlight">2021年，腾讯、国家天文台、复旦大学计算机科学技术学院联合启动“探星计划”</span>
          ，各方基于腾讯优图实验室领先的计算机视觉技术、腾讯云领先的计算能力，用云+AI帮助中国天眼FAST处理每天接收到的庞大数据量，通过视觉AI分析找到快速射电暴、脉冲星线索，截至目前已发现30颗脉冲星。今年，探星计划再度取得进展，首次通过AI技术发现2颗快速射电暴。
        </p>
        <p>与脉冲星探索相比，要在海量数据中发现更低频出现的快速射电暴，要求AI模型具备更高的精度、以及更快的计算速度。</p>
        <p>为了提高计算速度，腾讯针对快速射电暴探索，特别设计了一套全新的，端到端的AI算法。在同等算力下，这套全新的天文数据处理范式，推动信号处理效率相对常规处理流程提速1800倍。同时，结合腾讯云行业大模型辅助AI训练，通过自监督预训练+数据精调，提升模型精度，降低数据标注成本。</p>
        <p>
          <span class="mark-text highlight">在文化领域，腾讯创新性地将文字检测、摹本生成、字形匹配等AI算法，综合应用于甲骨文研究。</span>
          在“殷契文渊”甲骨文数据标注和处理基础上，通过定制化算法，不断丰富完善甲骨文模型库，截至目前已建立覆盖143万字的全球最大甲骨文单字数据库，提升甲骨文识别与考释、甲骨论著内容提取等的效率。通过探索甲骨文研究的人机协同新模式，云+AI将进一步焕活汉字源头，向更多人展现甲骨文的无限魅力。
        </p>
        <br>

        <div class="news-content-mark">
          <h2>发布《大模型时代的AI十大趋势报告》</h2>
          <h2>大模型技术驱动“人机共生”</h2>
        </div>
        <p>
          针对大模型AI技术发展，腾讯研究院、同济大学、腾讯云基于产学研三方在AI领域的研究，共同发布
          <span class="mark-text highlight">《人机共生——大模型时代的AI十大趋势报告》</span>
          ，从技术、应用、社会等角度，提出大模型时代的关键性趋势观察。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news37/news37_3.jpeg"/>
          </div>
        </div>
        <p>报告指出：</p>
        <p class="gray">涌现和融合是大模型时代重要的AI趋势，大模型推动AI进入AGI阶段，而多模态AI的发展则提供了解决复杂问题和实现多模态智能处理的能力。这些趋势为人工智能的快速进化和实现AGI目标带来了新的希望和机遇。</p>
        <p>随着大模型时代的来临，人机交互模式发生了革命性的变化，给个体创作者带来了前所未有的赋能。一方面，插件机制的出现，让平台开启了“应用时刻”，为模型的场景应用带来巨大的可能性。更有“灵魂”的数字人也有望成为下一代人机交互的入口。人机交互的革新将赋能个体成为超级生产者。</p>
        <p>而在AI助力产业发展方面，MaaS服务和垂直领域应用将是大模型时代AI发展的重要趋势，通过建设可控、可用的安全生态，推动模型的落地和应用，AI技术将为各行业带来更多的机遇和挑战。大模型时代带来的创新和发展，将推动人工智能走向更广阔的未来。</p>
        <p>腾讯研究院院长司晓在序言中表示：</p>
        <p class="gray">“随着AI的发展，浸润到其他行业，一个全民生产力爆发的时代似乎已迎来黎明。无论是普通的个人创作者，还是企业的管理者或决策者，把握对AI的认知及对趋势的判断都成为了一张通向未来的船票。报告希望能够提供一个全面、客观、深入的视角，促进对AI技术发展和应用的理性思考和积极探索。”</p>
        <p>
          <span class="mark-text highlight">技术发展是产业创新的活水源泉，技术应用的最终目的是服务于人。</span>
        </p>
        <p>腾讯持续投入先进技术研发，将高深复杂的前沿算法和理论，转换成低门槛的“AI应用”、“AI方案”，从数智人、TI平台到MaaS解决方案，激活实体产业创新动能。</p>
        <p>未来，腾讯将持续专注于“产业”这个新练兵场，从产业场景到研究领域，全面推动AI技术的创新普及应用，让“用得起”、“用得懂”的AI惠及更多场景、更广大用户。</p>

      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News33',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    font-size: 0;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .gray {
    color: rgb(136, 136, 136);
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News37.vue